exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__title___2szxH {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #292929;\n  border-bottom: 1px solid #c8c7d4;\n  margin-bottom: 20px;\n  padding-bottom: 7px; }\n", ""]);

// exports
exports.locals = {
	"title": "styles__title___2szxH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/VerifyModal/styles.scss
// module id = 1730
// module chunks = 6